import t from "../../Actions/LotCountingActions/types";
const initialState = {
  lotcounting_list: {},
};

const LotCounterReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.FETCHLOTCOUNTING: {
      return { ...state, lotcounting_list: action.payload };
    }
    case t.EDITLOTCOUNTING: {
      const lotcounting_list = JSON.parse(
        JSON.stringify(state.lotcounting_list)
      );
      console.log("in rduvcer", lotcounting_list);
      return {
        ...state,
        lotcounting_list: action.payload,
      };
    }
    default:
      return state;
  }
};

export default LotCounterReducer;
